/** @format */

export interface Spent {
  spent: string;
  isMillion: boolean;
}

const getSpentNumber = (spent: number | null): Spent => {
  if (spent === null) {
    return {
      spent: '',
      isMillion: false,
    };
  }

  const isMillion = spent >= 1000000;

  return {
    spent: isMillion
      ? new Intl.NumberFormat('ru-RU').format(spent / 1000000)
      : new Intl.NumberFormat('ru-RU').format(spent),
    isMillion,
  };
};

export {getSpentNumber};
